<div data-cy="message-confirm__page" *transloco="let t">

    <div>
        <h4>{{ data.title }}</h4>
    </div>
    <div class="popup-body">
        {{ data.body}}
    </div>
    <div *ngIf="!data.confirmCheck && !data.feature && data.type !== 'remove_subprject'">
        <mat-checkbox data-cy="message-confirm__checkbox" [checked]="confirmCheckSelected" (change)="confirmCheck($event.checked)">
            {{ data.confirmCheckText }}
        </mat-checkbox>
    </div>
    <div *ngIf="data.feature">
        <div class="d-flex justify-content-center">
            <mat-button-toggle-group data-cy="message-confirm__selected-feature" [(ngModel)]="selectedFeature" class="full-width" (ngModelChange)="onFeatureSelection($event)">
                <mat-button-toggle class="full-width" value="requirements">{{'requirements.label' | transloco | capitaliz}}</mat-button-toggle>
                <mat-button-toggle class="full-width" value="complaints">{{'complaints.label' | transloco | capitaliz}}</mat-button-toggle>
            </mat-button-toggle-group>
            <br>
            <br>
        </div>
        <div class="popup-footer">
            <div class="dialog-button-row">
                <button data-cy="message-confirm__select-feature-btn" type="button" mat-stroked-button (click)="selectFeature(false)">{{'cancel' | transloco }}</button>
                <button data-cy="message-confirm__btn" type="button" class="btn mdl-button mat-flat-button mdl-js-button mdl-button--raised" [disabled]="featureDisabled" (click)="selectFeature(true)">{{'save' | transloco | capitaliz}}</button>
            </div>
        </div>
    </div>

    <div *ngIf="!data.feature && data.type!== 'remove_subprject'" class="popup-footer">
        <div class="dialog-button-row">
            <button data-cy="message-confirm__btn-2" type="button" class="btn mdl-button  mdl-js-button mdl-button--raised" (click)="submit(false)">{{'cancel' | transloco | capitaliz}}</button>
            <button data-cy="message-confirm__btn-3" *ngIf="!data.confirmButton" type="button" class="btn mdl-button mat-flat-button mdl-js-button mdl-button--raised" [disabled]="!confirmCheckSelected" (click)="submit(true)">{{'confirm' | transloco | capitaliz}}</button>
        </div>
    </div>

    <div *ngIf="data.type == 'remove_subprject'" class="popup-footer">
        <button data-cy="message-confirm__btn-4" type="button" class="btn mdl-button  mdl-js-button mdl-button--raised" (click)="submit(false)">{{'cancel' | transloco | capitaliz}}</button>
        <button data-cy="message-confirm__btn-5" *ngIf="!data.confirmButton" type="button" class="btn mdl-button mat-flat-button mdl-js-button mdl-button--raised" (click)="submit(true)">{{'confirm' | transloco | capitaliz}}</button>
    </div>

</div>